export default __webpack_public_path__ + "static/media/regenera-seal.cfe4c5b9.png";